import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import cn from "~/utils/cn";

// "فو" and "نتا" are separate joining groups (و never joins forward), so splitting there keeps the Persian shaping intact.
const GROUPS = ["فو", "نتا"];
// Reduced motion: CSS pins the final, assembled state (no hydration mismatch from reading the preference in render).
const still = "motion-reduce:![transform:none]";

// The brand wordmark below the hero: the halves slide together, it grows to full size, and the outline fills in as you scroll past.
export default function Wordmark() {
  const ref = useRef<HTMLDivElement>(null);
  const { scrollYProgress: p } = useScroll({ target: ref, offset: ["start end", "end 65%"] });
  const scale = useTransform(p, [0, 1], [0.84, 1]);
  const xs = [useTransform(p, [0, 1], ["18%", "0%"]), useTransform(p, [0, 1], ["-18%", "0%"])];
  const fill = useTransform(p, [0.45, 1], [0, 1]);

  return (
    <div ref={ref} aria-hidden className="overflow-hidden pb-[clamp(8px,2vw,24px)]">
      <motion.div
        style={{ scale }}
        className={cn("flex select-none justify-center font-display text-[clamp(7.5rem,33vw,26rem)] font-black leading-[1.2]", still)}
      >
        {GROUPS.map((g, i) => (
          <motion.span key={g} style={{ x: xs[i] }} className={cn("grid", still)}>
            <span className="col-start-1 row-start-1 text-bg [-webkit-text-stroke:4px_var(--c-accent)] [paint-order:stroke_fill]">{g}</span>
            <motion.span style={{ opacity: fill }} className="col-start-1 row-start-1 text-accent motion-reduce:!opacity-100">
              {g}
            </motion.span>
          </motion.span>
        ))}
      </motion.div>
    </div>
  );
}
